import { createApi } from '@reduxjs/toolkit/query/react';
import fetchBaseQueryCSRF from '../helper';

interface GetConversionsKpisParams {
    workspaceId: number;
    startDate: string | null;
    endDate: string | null;
    compareStartDate?: string | null;
    compareEndDate?: string | null;
    countries?: string[];
    devices?: string[];
    platforms?: string[];
    dimension?: 'date' | 'country' | 'device' | 'platform';
    timestep?: string;
}

const conversionsApi = createApi({
    baseQuery: fetchBaseQueryCSRF({
        baseUrl: process.env.CROSS_API_URL,
    }),

    reducerPath: 'api.conversions',

    tagTypes: ['Conversions'],

    endpoints: (builder) => ({
        getConversionsKpis: builder.query<any, GetConversionsKpisParams>({
            query: ({
                workspaceId,
                startDate,
                endDate,
                compareStartDate,
                compareEndDate,
                countries = [],
                devices = [],
                platforms = [],
                dimension = 'date',
                timestep = 'year_week',
            }) => ({
                url: '/conversions/kpis',
                method: 'POST',
                body: JSON.stringify({
                    workspaceId,
                    startDate,
                    endDate,
                    compareStartDate,
                    compareEndDate,
                    countries,
                    devices,
                    platforms,
                    dimension,
                    timestep,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    Accept: 'application/json',
                },
            }),
        }),
    }),
});

export const {
    useGetConversionsKpisQuery,
} = conversionsApi;

export default conversionsApi;